import { ProjectedValue, ReferralCommission } from '.';

export type TProjectedValueReferralCommissionId = number;

export interface ProjectedValueReferralCommission {
  id: TProjectedValueReferralCommissionId;
  projected_value: ProjectedValue;
  referral_commission: ReferralCommission;
}
